import {useQuery} from '@tanstack/react-query'
import {agendaRecebimentoService} from '../services/AgendaRecebimentoService'
import {agendaRecebimentoKeys} from './query-keys'
import type {
  AgendaRecebimentoBookingDetailsResponse,
  AgendaRecebimentoBookingNFResponse,
  AgendaRecebimentoBookingResumeResponse,
  Identificador,
} from '../types'

function identificadorValido(id: Identificador | null): id is Identificador {
  return id !== null && id !== ''
}

interface ParametrosDrawerDetalhesQuery {
  agendaId: Identificador | null;
  aberto: boolean;
}

export function useAgendamentoDetalhesQuery({agendaId, aberto}: ParametrosDrawerDetalhesQuery) {
  const habilitado = aberto && identificadorValido(agendaId)

  return useQuery<AgendaRecebimentoBookingDetailsResponse[]>({
    queryKey: agendaRecebimentoKeys.detalhes(agendaId ?? ''),
    queryFn: async () => {
      if (!identificadorValido(agendaId)) return []

      const {data} = await agendaRecebimentoService.getBookingDetailsData(agendaId)
      return data
    },
    enabled: habilitado,
  })
}

export function useAgendamentoResumoQuery({agendaId, aberto}: ParametrosDrawerDetalhesQuery) {
  const habilitado = aberto && identificadorValido(agendaId)

  return useQuery<AgendaRecebimentoBookingResumeResponse>({
    queryKey: agendaRecebimentoKeys.resumo(agendaId ?? ''),
    queryFn: async () => {
      if (!identificadorValido(agendaId)) return {}

      const {data} = await agendaRecebimentoService.getBookingResumeData(agendaId)
      return data
    },
    enabled: habilitado,
  })
}

interface ParametrosNotasQuery {
  numeroNotaFiscal: Identificador | null;
  codigoUsuario: Identificador | null;
}

export function useAgendamentoNotasQuery({numeroNotaFiscal, codigoUsuario}: ParametrosNotasQuery) {
  const habilitado = identificadorValido(numeroNotaFiscal) && identificadorValido(codigoUsuario)

  return useQuery<AgendaRecebimentoBookingNFResponse[]>({
    queryKey: agendaRecebimentoKeys.notas(numeroNotaFiscal ?? '', codigoUsuario ?? ''),
    queryFn: async () => {
      if (!identificadorValido(numeroNotaFiscal) || !identificadorValido(codigoUsuario)) return []

      const {data} = await agendaRecebimentoService.getBookingNFsData(numeroNotaFiscal, codigoUsuario)
      return data
    },
    enabled: habilitado,
  })
}
